import { SxProps, Theme } from '@mui/material';
import { theme } from '~/theme';
import { commonStyles } from '~/theme/styles/commonStyles';

type TStyles = {
  buttonBox: SxProps<Theme>;
  modal: SxProps<Theme>;
  modalText: SxProps<Theme>;
  deleteDocumentText: SxProps<Theme>;
  deleteDocumentButton: SxProps<Theme>;
  table: SxProps<Theme>;
  tableBody: SxProps<Theme>;
  tableRow: SxProps<Theme>;
  tableCell: SxProps<Theme>;
  container: SxProps<Theme>;
  actionCell: SxProps<Theme>;
};

export const styles: TStyles = {
  buttonBox: () => ({
    display: 'flex',
    justifyContent: 'center',
  }),

  modal: () => ({
    textAlign: 'center',
    gap: 8,
  }),

  modalText: () => ({
    paddingBottom: 2,
    color: theme.palette.primary.main,
  }),

  deleteDocumentText: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    width: '100%',
    padding: '0 5%',
  }),

  deleteDocumentButton: () => ({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '20px',
    gap: '20px',
  }),
  table: (theme: Theme) => ({
    borderCollapse: 'separate',
    borderSpacing: 0,
    '& td, & th': {
      border: 0,
      borderRight: '1px solid',
      borderBottom: '1px solid',
      borderColor: theme.palette.grey.additionalGrey,
    },
    '& td:last-of-type, & th:last-of-type': { borderRight: 0 },
    '& tr:last-child td': { borderBottom: 0 },
  }),
  tableBody: (theme: Theme) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.grey.additionalGrey}`,
  }),
  tableRow: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 14,
    [theme.breakpoints.down('sm')]: {
      fontSize: 9,
    },
  }),
  tableCell: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    padding: 1,
    gap: 1,
    border: 0,
  },
  actionCell: {
    maxWidth: 60,
    justifyContent: 'center',
  },
  container: {
    ...commonStyles.columnFlexContainer,
    gap: 3,
    alignItems: 'center',
  },
};
